const routeUserInfo = [
  {
    path: '/user_info',
    name: 'UserInfoPage',
    component: () => import('@/pages/permission/PermissionPage'),
    meta: {
      layout: 'HomeLayout',
      user_info_route: true,
    },
  },
];

export default routeUserInfo;
